module.exports = __webpack_public_path__ + "img/customers_say_01.f104533a.jpg";